<template lang="pug">
  .panel-page-white
    .panel-white.body-1.mx-auto
      PageHeader User Search Results
      .d-flex.flex-row-reverse.mt-3
        div
          button.btn.btn-primary(@click.prevent="downloadCsv('usersearch.csv', csvRecords)") Download CSV
      Datatable(
        :entries="results"
        :columns="columns"
        :perPage="6"
      ).mt-3.body-3
        template(slot-scope="props")
          tr
            td
              router-link(:to="{name: 'user_search_view', query: {id: props.entry.id}}") {{ props.entry.editable ? 'View' : ''}}
            td {{ props.entry.username }}
            td {{ props.entry.lastName }}, {{ props.entry.firstName }}
            td {{ removeDuplicationFromArrays(props.entry.states).join(', ')}}
            td {{ props.entry.agencyDescriptions.join(', ') }}
            td {{ props.entry.email }}
            td {{ props.entry.workPhone }}
            td {{ props.entry.status }}
            td {{ props.entry.userLevel }}
            td {{ props.entry.createdByUsername || 'Self-Registered' }}
</template>

<script>
import PageHeader from '@/components/PageHeader'
import Datatable from '@/components/Datatable'
import axios from '@/lib/axios'
import { downloadCsv } from '@/lib/csv'
import { loadForm, formItem, clearForm } from '@/lib/formstore'
import { removeDuplicationFromArrays, globalError } from '@/lib/utils'

export default {
  name: 'UserSearchResults',
  data() {
    return {
      columns: [
        'Action',
        'User Name',
        'Name',
        'State',
        'Agency',
        'Email',
        'Phone Number',
        'Account Status',
        'User Level',
        'Created By',
      ],
      results: [],
      username: '',
      lastName: '',
      email: '',
      states: [],
      selectedAgencies: [],
      agencyType: '',
      status: [],
      userLevel: '',
    }
  },

  methods: { downloadCsv, removeDuplicationFromArrays },
  computed: {
    csvRecords() {
      return this.results.map(r => {
        return {
          Username: r.username,
          Name: `"${r.lastName}, ${r.firstName}"`,
          State: `"${removeDuplicationFromArrays(r.states).join(', ')}"`,
          Agency: `"${r.agencyDescriptions.join(', ')}"`,
          Email: r.email,
          'Phone Number': r.workPhone || '',
          Status: r.status,
          'User Level': r.userLevel,
          'Created By': r.createdByUsername || '',
        }
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === 'user_search_view') {
      clearForm('user_search_custom_back_button')
    }
    axios()
      .post('/api/admin/search_users', {
        username: formItem('usersearch', 'username'),
        lastName: formItem('usersearch', 'lastName'),
        email: formItem('usersearch', 'email'),
        agencies:
          formItem('usersearch', 'agencyType') === 'all'
            ? []
            : formItem('usersearch', 'selectedAgencies').map(a => a.id),
        status: formItem('usersearch', 'status'),
        States: formItem('usersearch', 'states'),
        statesList: formItem('usersearch', 'selectedStates').map(
          s => s.abbreviation,
        ),
        // we are appending a wildcard character to the end of each userLevel
        // so that our query will also match our exception ('{role}_exc') roles
        userLevel: formItem('usersearch', 'userLevel').map(userLevel => `${userLevel}%`),
      })
      .then(resp => {
        scrollTo(0, 0)
        next(vm => (vm.results = resp.data))
      })
      .catch(err => globalError(err))
  },
  mounted: loadForm(
    'usersearch',
    'username',
    'lastName',
    'email',
    'states',
    'selectedAgencies',
    'agencyType',
    'status',
    'userLevel',
  ),
  components: { PageHeader, Datatable },
}
</script>

<style lang="scss" scoped>
.panel-white {
  width: 1007px;
}
</style>
